import { useSelector } from "react-redux";

// Canonical city values are stored in English in the database (matches existing
// ride records and the Expo app); labels are localized at render time.
export const CITIES = [
  { value: "Tbilisi", ge: "თბილისი" },
  { value: "Batumi", ge: "ბათუმი" },
  { value: "Kutaisi", ge: "ქუთაისი" },
  { value: "Zugdidi", ge: "ზუგდიდი" },
  { value: "Rustavi", ge: "რუსთავი" },
  { value: "Gori", ge: "გორი" },
  { value: "Poti", ge: "ფოთი" },
  { value: "Khashuri", ge: "ხაშური" },
  { value: "Samtredia", ge: "სამტრედია" },
  { value: "Senaki", ge: "სენაკი" },
  { value: "Zestafoni", ge: "ზესტაფონი" },
  { value: "Marneuli", ge: "მარნეული" },
  { value: "Telavi", ge: "თელავი" },
  { value: "Kobuleti", ge: "ქობულეთი" },
  { value: "Akhaltsikhe", ge: "ახალციხე" },
  { value: "Ozurgeti", ge: "ოზურგეთი" },
  { value: "Kaspi", ge: "კასპი" },
  { value: "Borjomi", ge: "ბორჯომი" },
  { value: "Mtskheta", ge: "მცხეთა" },
  { value: "Gudauri", ge: "გუდაური" },
  { value: "Bakuriani", ge: "ბაკურიანი" },
  { value: "Sachkhere", ge: "საჩხერე" },
  { value: "Mestia", ge: "მესტია" },
  { value: "Lagodekhi", ge: "ლაგოდეხი" },
  { value: "Chiatura", ge: "ჭიათურა" },
  { value: "Kazbegi", ge: "ყაზბეგი" },
  { value: "Gurjaani", ge: "გურჯაანი" },
  { value: "Lanchkhuti", ge: "ლანჩხუთი" },
  { value: "Martvili", ge: "მარტვილი" },
  { value: "Terjola", ge: "თერჯოლა" },
  { value: "Kvareli", ge: "ყვარელი" },
  { value: "Baghdati", ge: "ბაღდათი" },
  { value: "Kacreti", ge: "კაჭრეთი" },
  { value: "Tskaltubo", ge: "წყალტუბო" },
  { value: "Ambrolauri", ge: "ამბროლაური" },
  { value: "Dusheti", ge: "დუშეთი" },
  { value: "Tkibuli", ge: "ტყიბული" },
  { value: "Kharagauli", ge: "ხარაგაული" },
  { value: "Sighnaghi", ge: "სიღნაღი" },
  { value: "Bolnisi", ge: "ბოლნისი" },
  { value: "Sagarejo", ge: "საგარეჯო" },
  { value: "Akhalkalaki", ge: "ახალქალაქი" },
  { value: "Tsalenjikha", ge: "წალენჯიხა" },
  { value: "Kakheti", ge: "კახეთი" },
];

// Ride preference badges (BlaBlaCar-style). Keys are stored in the ride
// record; labels resolve through i18n at render time.
export const RIDE_BADGES = [
  { key: "noSmoking", icon: "🚭", tKey: "badgeNoSmoking" },
  { key: "pets", icon: "🐶", tKey: "badgePets" },
  { key: "music", icon: "🎵", tKey: "badgeMusic" },
  { key: "ac", icon: "❄️", tKey: "badgeAc" },
  { key: "luggage", icon: "🧳", tKey: "badgeLuggage" },
  { key: "maxTwoBack", icon: "💺", tKey: "badgeMaxTwoBack" },
];

export const cityLabel = (value, lang) => {
  const city = CITIES.find((c) => c.value === (value || "").trim());
  if (!city) return value;
  return lang === "GE" ? city.ge : city.value;
};

const STRINGS = {
  EN: {
    // nav
    findRide: "Find a ride",
    publishRide: "Publish a ride",
    requestsNav: "Ride requests",
    profile: "Profile",
    adminPanel: "Admin panel",
    signIn: "Sign in",
    signOut: "Sign out",
    // hero
    heroTitle: "Carpooling across Georgia",
    heroSubtitle:
      "Find a ride between cities or share your car — split fuel costs, travel cheaper, meet good people.",
    heroFind: "Find a ride",
    heroDrive: "I'm driving",
    // SEO (page titles + descriptions)
    seoHomeTitle: "Carpool & intercity rides across Georgia",
    seoHomeDesc:
      "Find or publish a shared car ride between Tbilisi, Batumi, Kutaisi and other Georgian cities. Split fuel costs and travel cheaper with Gamiyole.",
    seoFindTitle: "Find a ride between cities",
    seoFindDesc:
      "Search shared car rides between Georgian cities — pick your route and date, see the driver, price and free seats.",
    seoRouteDesc:
      "Shared car rides on this route across Georgia. See drivers, prices and free seats, or publish your own ride.",
    seoPublishTitle: "Publish a ride",
    seoPublishDesc:
      "Driving between cities? Publish your route, set the price and fill your empty seats. Free to post on Gamiyole.",
    seoRequestsTitle: "Ride requests",
    seoRequestsDesc:
      "See passengers looking for rides between Georgian cities, or post your own request so drivers can find you.",
    seoPrivacyTitle: "Privacy policy",
    seoPrivacyDesc: "How Gamiyole collects, uses and protects your data.",
    // search
    from: "From",
    to: "To",
    date: "Date",
    when: "When",
    dateAny: "Any date",
    dateToday: "Today",
    dateTomorrow: "Tomorrow",
    dateWeek: "Within a week",
    datePick: "Exact date…",
    search: "Search",
    swap: "Swap cities",
    selectCity: "Select city…",
    anyCity: "Any city",
    noCityMatch: "No matching city",
    // rides
    upcomingRides: "Upcoming rides",
    resultsFor: "Rides",
    filterType: "Type",
    filterPrice: "Price",
    typeAll: "All",
    typeCarpool: "Carpool",
    typeBus: "Bus",
    priceAll: "Any",
    priceFree: "Free",
    pricePaid: "Paid",
    free: "Free",
    busBadge: "Bus",
    externalBadge: "From Facebook",
    externalNote: "Spotted in a Facebook group — we couldn't verify it. Open the original post to check details and contact the driver.",
    externalRequestNote: "Spotted in a Facebook group — we couldn't verify it. Open the original post to check details and contact the passenger.",
    externalViewPost: "View original post",
    externalViewGroup: "Find it in the group",
    externalSeats: "seats mentioned",
    rideTypeLabel: "Ride type",
    noRides: "No rides found for this route yet.",
    noRidesHint: "Try another date, or check back soon — new rides are published daily.",
    // Ride requests
    requestsNavShort: "Requests",
    requestsTitle: "Request a ride",
    requestsSubtitle:
      "No ride for your route yet? Post where and when you want to travel — drivers see requests here and can offer you a trip.",
    howItWorks: "How it works",
    reqHow1: "Post your route and travel dates",
    reqHow2: "Drivers browsing requests see it",
    reqHow3: "A driver contacts you or publishes a matching ride",
    recentRequests: "Recent requests",
    postRequest: "Post a ride request",
    postRequestHint: "Can't find a ride? Let drivers know where and when you want to travel.",
    requestNote: "Note (optional)",
    requestNotePlaceholder: "e.g. 2 passengers, flexible on time, some luggage…",
    dateFrom: "Earliest date",
    dateTo: "Latest date",
    submitRequest: "Post request",
    posting: "Posting…",
    requestPosted: "Posted! Drivers can now see your request.",
    noRequests: "No ride requests yet.",
    noRequestsHint: "Be the first — post where you'd like to go.",
    noMatchingRequests: "No requests match these filters.",
    changeRequestFilters: "Try another route or travel date.",
    clearFilters: "Clear filters",
    yourRequest: "Your request",
    deleteRequest: "Delete",
    deleteRequestConfirm: "Delete this ride request?",
    passengersLooking: "Passengers looking for rides",
    viewAllRequests: "View all requests",
    contactPassenger: "Contact",
    signInToRequest: "Sign in to post a ride request.",
    errRequestCities: "Select both departure and destination.",
    errRequestSameCity: "Departure and destination must differ.",
    errRequestDates: "Pick a valid date range (latest can't be before earliest).",
    errRequestPast: "Earliest date can't be in the past.",
    seat: "seat",
    seats: "seats",
    seatsLeft: "left",
    soldOut: "Full",
    perSeat: "per seat",
    book: "Book a seat",
    booked: "Booked",
    cancelBooking: "Cancel booking",
    bookSignIn: "Sign in to book",
    yourRide: "Your ride",
    cancelRide: "Cancel ride",
    ownRide: "This is your ride",
    fullyBooked: "Sorry, this ride is fully booked.",
    alreadyBooked: "You have already booked this ride.",
    bookingConfirmed: "Seat booked! The driver can see your name and contact you.",
    // how it works
    howTitle: "How Gamiyole works",
    how1Title: "Search your route",
    how1Text: "Pick where you're leaving from, where you're going and when.",
    how2Title: "Book your seat",
    how2Text: "Check the driver's profile, reviews and car, then reserve a seat.",
    how3Title: "Travel together",
    how3Text: "Meet up, share the trip and split the cost. Leave a review after.",
    trustTitle: "Built on trust",
    trustText:
      "Every driver and passenger has a public profile with reviews from real trips, so you always know who you're travelling with.",
    popularRoutes: "Popular routes",
    appPromoTitle: "Gamiyole in your pocket",
    appPromoText:
      "Search, book and publish rides on the go. Available now on iOS; coming soon to Android.",
    downloadOn: "Download on the",
    comingSoon: "Coming soon",
    faqTitle: "Frequently asked questions",
    faq1q: "How do I book a seat?",
    faq1a:
      "Search your route, open a ride, check the driver's profile and reviews, and tap Book a seat. Your seat is reserved instantly and the driver sees your name.",
    faq2q: "How do I pay?",
    faq2a:
      "You pay the driver directly, usually in cash during the trip. The price per seat is always shown before you book. Gamiyole doesn't charge any fees.",
    faq3q: "Is Gamiyole free to use?",
    faq3a:
      "Yes — no commissions and no booking fees. The only thing you pay is the ride price, directly to the driver. Some rides are even published as free.",
    faq4q: "How do I publish a ride as a driver?",
    faq4a:
      "Complete your profile as a driver, then publish a one-time ride or set up a weekly routine — your recurring rides are published automatically for the whole period.",
    faq5q: "What are the bus listings?",
    faq5a:
      "Alongside carpools, Gamiyole also lists intercity bus departures, marked with a bus badge. Use the filters to show only carpools or only buses.",
    faq6q: "How do reviews work?",
    faq6a:
      "After a trip, drivers and passengers can rate each other with stars and a comment. One review per member — editing it replaces the previous one, so ratings stay honest.",
    // auth
    signInTitle: "Welcome back",
    signUpTitle: "Create your account",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm password",
    signUp: "Sign up",
    signingIn: "Signing in…",
    creatingAccount: "Creating account…",
    orContinueWith: "or",
    continueWithGoogle: "Continue with Google",
    noAccount: "New to Gamiyole?",
    haveAccount: "Already have an account?",
    errInvalidCredentials: "Wrong email or password.",
    errEmailInUse: "This email is already registered.",
    errWeakPassword: "Password must be at least 6 characters.",
    errPasswordMatch: "Passwords do not match.",
    errInvalidEmail: "Please enter a valid email address.",
    errGeneric: "Something went wrong. Please try again.",
    // profile
    aboutMe: "About me",
    phone: "Phone number",
    car: "Car",
    carModel: "Car model",
    numberPlate: "Number plate",
    carPhotos: "Car photos",
    facebook: "Facebook profile",
    facebookHint: "facebook.com/yourname (optional)",
    viewFacebook: "Facebook",
    memberSince: "Member since",
    driver: "Driver",
    passenger: "Passenger",
    verified: "Verified",
    editProfile: "Edit profile",
    deleteAccount: "Delete account",
    deletingAccount: "Deleting account…",
    deleteAccountConfirmMsg:
      "This permanently deletes your account and all your data — profile, published rides, bookings and reviews. This cannot be undone. Continue?",
    deleteAccountFail: "Could not delete your account. Please try again.",
    completeProfileTitle: "Complete your profile",
    completeProfileHint:
      "A complete profile helps other members trust you. Name and a few words about you are required.",
    fullName: "Full name",
    age: "Age",
    iAmA: "I am a…",
    driverHint: "I drive and publish rides",
    passengerHint: "I book seats with drivers",
    save: "Save profile",
    saving: "Saving…",
    profileSaved: "Profile saved.",
    errName: "Enter your name (at least 2 characters).",
    errAge: "You must be 18 or older.",
    errPhone: "Enter a 9-digit phone number, e.g. 555123456.",
    errAbout: "Write a few words about yourself.",
    errCarModel: "Enter your car model.",
    errPlate: "Plate format: AA-123-AA.",
    changePhoto: "Change photo",
    uploading: "Uploading…",
    publishedRides: "Published rides",
    myBookings: "My bookings",
    noBookings: "You haven't booked any rides yet.",
    accountDisabledBanner:
      "Your driver access has been suspended by an administrator. You can't publish rides. Contact info@gamiyole.me if you think this is a mistake.",
    // reviews
    reviews: "Reviews",
    noReviews: "No reviews yet.",
    leaveReview: "How was your trip with",
    reviewPlaceholder: "Share a few words about the trip…",
    sendReview: "Send review",
    reviewSent: "Thanks! Your review has been posted.",
    reviewNeedsRating: "Please choose a star rating.",
    signInToReview: "Sign in to leave a review.",
    yourRating: "Your rating",
    // publish
    publishTitle: "Publish a ride",
    publishHint: "Fill in your route and seats — passengers will book directly.",
    price: "Price per seat (GEL)",
    seatsOffered: "Seats offered",
    departureTime: "Departure time",
    publish: "Publish ride",
    publishing: "Publishing…",
    ridePublished: "Your ride is live!",
    errCities: "Select both departure and destination.",
    errSameCity: "Departure and destination must differ.",
    errDate: "Pick today or a future date.",
    errTime: "Set a departure time.",
    errPrice: "Enter a price between 0 and 500 GEL (0 = free ride).",
    errSeats: "Seats must be between 1 and 8.",
    completeProfileFirst: "Complete your profile before publishing a ride.",
    signInToPublish: "Sign in to publish a ride.",
    prefsLabel: "Preferences",
    commentLabel: "Comment (optional)",
    commentPlaceholder: "e.g. Meeting point, luggage space, stops on the way…",
    badgeNoSmoking: "No smoking",
    badgePets: "Pets OK",
    badgeMusic: "Music",
    badgeAc: "A/C",
    badgeLuggage: "Big luggage OK",
    badgeMaxTwoBack: "Max 2 in back",
    modeOnce: "One-time",
    modeRoutine: "Weekly routine",
    routineHint:
      "Drive the same route regularly? Pick the days and how long the schedule runs — every ride in that period is published immediately.",
    repeatOn: "Repeat on",
    durationLabel: "Active for",
    months1: "1 month",
    months2: "2 months",
    months3: "3 months",
    untilDate: "until",
    saveRoutine: "Save routine",
    routineSaved: "Routine saved — all rides for the period are published.",
    myRoutines: "My routines",
    paused: "Paused",
    pause: "Pause",
    resume: "Resume",
    deleteBtn: "Delete",
    errDays: "Pick at least one day of the week.",
    deleteRoutineConfirm:
      "Delete this routine? Its upcoming auto-published rides will be cancelled.",
    // admin
    adminTitle: "Admin panel",
    adminSubtitle: "Manage drivers, rides and reviews",
    adminDrivers: "Drivers",
    adminRides: "Active rides",
    adminDisabled: "Suspended",
    adminSearch: "Search by name, email or phone…",
    adminAll: "All users",
    adminOnlyDrivers: "Drivers",
    adminOnlySuspended: "Suspended",
    adminUser: "User",
    adminContact: "Contact",
    adminRating: "Rating",
    adminRidesCol: "Rides",
    adminStatus: "Status",
    adminActions: "Actions",
    adminActive: "Active",
    adminSuspendedBadge: "Suspended",
    adminSuspend: "Suspend",
    adminRestore: "Restore",
    adminVerify: "Verify",
    adminUnverify: "Unverify",
    adminVerified: "Verified",
    adminView: "View",
    adminSuspendConfirm:
      "Suspend driver access for this user? They will no longer be able to publish rides.",
    adminNoUsers: "No users match this filter.",
    adminRidesTitle: "Active rides",
    adminNoRides: "No active rides.",
    adminCancelRide: "Cancel",
    adminDeleteRide: "Delete",
    adminDeleteRideConfirm: "Permanently delete this ride?",
    adminNotAllowed: "You don't have access to the admin panel.",
    adminReviewsFor: "reviews",
    adminDeleteReview: "Delete review",
    adminDeleteReviewConfirm: "Delete this review permanently?",
    // misc
    loading: "Loading…",
    contact: "Contact",
    privacyPolicy: "Privacy Policy",
    allRights: "All rights reserved",
    footerTag: "Carpooling in Georgia — travel together, pay less.",
    backHome: "Back to home",
    call: "Call",
  },
  GE: {
    findRide: "მოძებნე მგზავრობა",
    publishRide: "გამოაქვეყნე მგზავრობა",
    requestsNav: "მოთხოვნები",
    profile: "პროფილი",
    adminPanel: "ადმინ პანელი",
    signIn: "შესვლა",
    signOut: "გასვლა",
    heroTitle: "იმგზავრე იაფად საქართველოში",
    heroSubtitle:
      "იპოვე მგზავრობა ქალაქებს შორის ან წაიყვანე მგზავრები — გაიყავით საწვავის ხარჯი და იმგზავრეთ ერთად.",
    heroFind: "მოძებნე მგზავრობა",
    heroDrive: "მე ვმართავ",
    // SEO (page titles + descriptions)
    seoHomeTitle: "გააზიარე მგზავრობა ქალაქებს შორის საქართველოში",
    seoHomeDesc:
      "იპოვე ან გამოაქვეყნე გასაზიარებელი მგზავრობა თბილისი–ბათუმი, ქუთაისი, ზუგდიდი და სხვა ქალაქებს შორის. გაიყავი საწვავის ხარჯი და იმგზავრე იაფად.",
    seoFindTitle: "იპოვე მგზავრობა ქალაქებს შორის",
    seoFindDesc:
      "მოძებნე გასაზიარებელი მგზავრობა ქართულ ქალაქებს შორის — აირჩიე მარშრუტი და თარიღი, ნახე მძღოლი, ფასი და თავისუფალი ადგილები.",
    seoRouteDesc:
      "გასაზიარებელი მგზავრობა ამ მარშრუტზე. ნახე მძღოლები, ფასები და თავისუფალი ადგილები, ან გამოაქვეყნე შენი მგზავრობა.",
    seoPublishTitle: "გამოაქვეყნე მგზავრობა",
    seoPublishDesc:
      "მიემგზავრები ქალაქებს შორის? გამოაქვეყნე მარშრუტი, დააფიქსირე ფასი და შეავსე ცარიელი ადგილები. გამოქვეყნება უფასოა.",
    seoRequestsTitle: "მგზავრობის მოთხოვნები",
    seoRequestsDesc:
      "ნახე მგზავრები, რომლებიც ეძებენ მგზავრობას ქალაქებს შორის, ან დაამატე შენი მოთხოვნა, რომ მძღოლებმა გიპოვონ.",
    seoPrivacyTitle: "კონფიდენციალურობის პოლიტიკა",
    seoPrivacyDesc: "როგორ აგროვებს, იყენებს და იცავს Gamiyole შენს მონაცემებს.",
    from: "საიდან",
    to: "სად",
    date: "თარიღი",
    when: "როდის",
    dateAny: "ნებისმიერ დღეს",
    dateToday: "დღეს",
    dateTomorrow: "ხვალ",
    dateWeek: "ერთ კვირაში",
    datePick: "კონკრეტული თარიღი…",
    search: "ძებნა",
    swap: "ქალაქების გაცვლა",
    selectCity: "აირჩიე ქალაქი…",
    anyCity: "ნებისმიერი ქალაქი",
    noCityMatch: "ქალაქი ვერ მოიძებნა",
    upcomingRides: "უახლოესი მგზავრობები",
    resultsFor: "მგზავრობები",
    filterType: "ტიპი",
    filterPrice: "ფასი",
    typeAll: "ყველა",
    typeCarpool: "თანამგზავრობა",
    typeBus: "ავტობუსი",
    priceAll: "ნებისმიერი",
    priceFree: "უფასო",
    pricePaid: "ფასიანი",
    free: "უფასო",
    busBadge: "ავტობუსი",
    externalBadge: "ფეისბუქიდან",
    externalNote: "ნაპოვნია ფეისბუქის ჯგუფში — ვერ გადავამოწმეთ. გახსენი ორიგინალი პოსტი დეტალების სანახავად და მძღოლთან დასაკავშირებლად.",
    externalRequestNote: "ნაპოვნია ფეისბუქის ჯგუფში — ვერ გადავამოწმეთ. გახსენი ორიგინალი პოსტი დეტალების სანახავად და მგზავრთან დასაკავშირებლად.",
    externalViewPost: "ნახე ორიგინალი პოსტი",
    externalViewGroup: "იპოვე ჯგუფში",
    externalSeats: "მითითებული ადგილი",
    rideTypeLabel: "მგზავრობის ტიპი",
    noRides: "ამ მარშრუტზე მგზავრობა ვერ მოიძებნა.",
    noRidesHint: "სცადე სხვა თარიღი ან შემოიხედე მოგვიანებით — ახალი მგზავრობები ყოველდღე ემატება.",
    // Ride requests
    requestsNavShort: "მოთხოვნები",
    requestsTitle: "მოითხოვე მგზავრობა",
    requestsSubtitle:
      "ვერ იპოვე მგზავრობა შენს მარშრუტზე? მიუთითე სად და როდის გინდა გამგზავრება — მძღოლები ხედავენ მოთხოვნებს და შემოგთავაზებენ მგზავრობას.",
    howItWorks: "როგორ მუშაობს",
    reqHow1: "მიუთითე მარშრუტი და მგზავრობის თარიღები",
    reqHow2: "მძღოლები ხედავენ შენს მოთხოვნას",
    reqHow3: "მძღოლი დაგიკავშირდება ან გამოაქვეყნებს შესაბამის მგზავრობას",
    recentRequests: "ბოლო მოთხოვნები",
    postRequest: "დაამატე მოთხოვნა",
    postRequestHint: "ვერ იპოვე მგზავრობა? აცნობე მძღოლებს, სად და როდის გინდა გამგზავრება.",
    requestNote: "შენიშვნა (არასავალდებულო)",
    requestNotePlaceholder: "მაგ. 2 მგზავრი, დროში მოქნილი, მცირე ბარგი…",
    dateFrom: "ყველაზე ადრე",
    dateTo: "ყველაზე გვიან",
    submitRequest: "დამატება",
    posting: "ემატება…",
    requestPosted: "დაემატა! მძღოლები ხედავენ შენს მოთხოვნას.",
    noRequests: "მოთხოვნები ჯერ არ არის.",
    noRequestsHint: "იყავი პირველი — დაამატე, სად გინდა წასვლა.",
    noMatchingRequests: "ამ ფილტრებით მოთხოვნები ვერ მოიძებნა.",
    changeRequestFilters: "სცადე სხვა მარშრუტი ან მგზავრობის თარიღი.",
    clearFilters: "ფილტრების გასუფთავება",
    yourRequest: "შენი მოთხოვნა",
    deleteRequest: "წაშლა",
    deleteRequestConfirm: "წაიშალოს ეს მოთხოვნა?",
    passengersLooking: "მგზავრები, რომლებიც ეძებენ მგზავრობას",
    viewAllRequests: "ყველა მოთხოვნა",
    contactPassenger: "დაკავშირება",
    signInToRequest: "მოთხოვნის დასამატებლად შედი სისტემაში.",
    errRequestCities: "აირჩიე გასვლის და ჩასვლის ქალაქები.",
    errRequestSameCity: "გასვლის და ჩასვლის ქალაქები უნდა განსხვავდებოდეს.",
    errRequestDates: "აირჩიე სწორი პერიოდი (ბოლო თარიღი არ უნდა იყოს პირველზე ადრე).",
    errRequestPast: "პირველი თარიღი წარსულში ვერ იქნება.",
    seat: "ადგილი",
    seats: "ადგილი",
    seatsLeft: "დარჩა",
    soldOut: "შევსებულია",
    perSeat: "ადგილზე",
    book: "დაჯავშნე ადგილი",
    booked: "დაჯავშნილია",
    cancelBooking: "ჯავშნის გაუქმება",
    bookSignIn: "დასაჯავშნად შედი სისტემაში",
    yourRide: "შენი მგზავრობა",
    cancelRide: "მგზავრობის გაუქმება",
    ownRide: "ეს შენი მგზავრობაა",
    fullyBooked: "სამწუხაროდ, ადგილები აღარ არის.",
    alreadyBooked: "ეს მგზავრობა უკვე დაჯავშნილი გაქვს.",
    bookingConfirmed: "ადგილი დაჯავშნილია! მძღოლი დაინახავს შენს სახელს.",
    howTitle: "როგორ მუშაობს Gamiyole",
    how1Title: "მოძებნე მარშრუტი",
    how1Text: "აირჩიე საიდან მიემგზავრები, სად და როდის.",
    how2Title: "დაჯავშნე ადგილი",
    how2Text: "ნახე მძღოლის პროფილი, შეფასებები და მანქანა, შემდეგ დაჯავშნე.",
    how3Title: "იმგზავრეთ ერთად",
    how3Text: "შეხვდით, გაიყავით ხარჯი და მგზავრობის შემდეგ დაწერე შეფასება.",
    trustTitle: "ნდობაზე აგებული",
    trustText:
      "ყველა მძღოლსა და მგზავრს აქვს საჯარო პროფილი რეალური მგზავრობების შეფასებებით — ყოველთვის იცი, ვისთან მგზავრობ.",
    popularRoutes: "პოპულარული მარშრუტები",
    appPromoTitle: "Gamiyole შენს ჯიბეში",
    appPromoText:
      "მოძებნე, დაჯავშნე და გამოაქვეყნე მგზავრობები გზაშივე. Gamiyole უკვე ხელმისაწვდომია iOS-ზე; Android-ზე მალე გამოვა.",
    downloadOn: "ჩამოტვირთე",
    comingSoon: "მალე",
    faqTitle: "ხშირად დასმული კითხვები",
    faq1q: "როგორ დავჯავშნო ადგილი?",
    faq1a:
      "მოძებნე მარშრუტი, გახსენი მგზავრობა, ნახე მძღოლის პროფილი და შეფასებები და დააჭირე „დაჯავშნე ადგილი“-ს. ადგილი მაშინვე ჯავშნდება და მძღოლი შენს სახელს დაინახავს.",
    faq2q: "როგორ ვიხდი?",
    faq2a:
      "მძღოლს პირდაპირ უხდი, ჩვეულებრივ ნაღდი ფულით, მგზავრობისას. ფასი ერთ ადგილზე ყოველთვის ჯავშნამდე ჩანს. Gamiyole არავითარ საკომისიოს არ იღებს.",
    faq3q: "Gamiyole უფასოა?",
    faq3a:
      "დიახ — არც საკომისიო და არც ჯავშნის საფასური. იხდი მხოლოდ მგზავრობის ფასს, პირდაპირ მძღოლთან. ზოგიერთი მგზავრობა უფასოც კია.",
    faq4q: "როგორ გამოვაქვეყნო მგზავრობა მძღოლად?",
    faq4a:
      "შეავსე პროფილი მძღოლის სტატუსით და გამოაქვეყნე ერთჯერადი მგზავრობა ან შექმენი ყოველკვირეული განრიგი — განმეორებადი მგზავრობები მთელი პერიოდისთვის ავტომატურად ქვეყნდება.",
    faq5q: "რა არის ავტობუსის განცხადებები?",
    faq5a:
      "თანამგზავრობის გარდა Gamiyole საქალაქთაშორისო ავტობუსების გასვლებსაც აჩვენებს, ავტობუსის ნიშნით. ფილტრებით შეგიძლია მხოლოდ თანამგზავრობა ან მხოლოდ ავტობუსები ნახო.",
    faq6q: "როგორ მუშაობს შეფასებები?",
    faq6a:
      "მგზავრობის შემდეგ მძღოლი და მგზავრი ერთმანეთს ვარსკვლავებითა და კომენტარით აფასებენ. თითო წევრზე ერთი შეფასება — რედაქტირება წინას ანაცვლებს, ამიტომ რეიტინგები სანდო რჩება.",
    signInTitle: "კეთილი იყოს დაბრუნება",
    signUpTitle: "შექმენი ანგარიში",
    email: "ელფოსტა",
    password: "პაროლი",
    confirmPassword: "გაიმეორე პაროლი",
    signUp: "რეგისტრაცია",
    signingIn: "შესვლა…",
    creatingAccount: "ანგარიში იქმნება…",
    orContinueWith: "ან",
    continueWithGoogle: "Google-ით გაგრძელება",
    noAccount: "პირველად ხარ Gamiyole-ზე?",
    haveAccount: "უკვე გაქვს ანგარიში?",
    errInvalidCredentials: "ელფოსტა ან პაროლი არასწორია.",
    errEmailInUse: "ეს ელფოსტა უკვე რეგისტრირებულია.",
    errWeakPassword: "პაროლი მინიმუმ 6 სიმბოლო უნდა იყოს.",
    errPasswordMatch: "პაროლები არ ემთხვევა.",
    errInvalidEmail: "შეიყვანე სწორი ელფოსტა.",
    errGeneric: "რაღაც შეცდომაა. სცადე თავიდან.",
    aboutMe: "ჩემ შესახებ",
    phone: "ტელეფონის ნომერი",
    car: "მანქანა",
    carModel: "მანქანის მოდელი",
    numberPlate: "სახელმწიფო ნომერი",
    carPhotos: "მანქანის ფოტოები",
    facebook: "Facebook პროფილი",
    facebookHint: "facebook.com/yourname (არასავალდებულო)",
    viewFacebook: "Facebook",
    memberSince: "წევრია",
    driver: "მძღოლი",
    passenger: "მგზავრი",
    verified: "დადასტურებული",
    editProfile: "პროფილის რედაქტირება",
    deleteAccount: "ანგარიშის წაშლა",
    deletingAccount: "ანგარიში იშლება…",
    deleteAccountConfirmMsg:
      "ეს სამუდამოდ წაშლის შენს ანგარიშსა და ყველა მონაცემს — პროფილს, გამოქვეყნებულ მგზავრობებს, ჯავშნებსა და შეფასებებს. ამის დაბრუნება შეუძლებელია. გავაგრძელო?",
    deleteAccountFail: "ანგარიშის წაშლა ვერ მოხერხდა. სცადე თავიდან.",
    completeProfileTitle: "შეავსე პროფილი",
    completeProfileHint:
      "შევსებული პროფილი ნდობას მატებს. სახელი და რამდენიმე სიტყვა შენ შესახებ აუცილებელია.",
    fullName: "სახელი და გვარი",
    age: "ასაკი",
    iAmA: "მე ვარ…",
    driverHint: "ვმართავ და ვაქვეყნებ მგზავრობებს",
    passengerHint: "ვჯავშნი ადგილებს მძღოლებთან",
    save: "შენახვა",
    saving: "ინახება…",
    profileSaved: "პროფილი შენახულია.",
    errName: "შეიყვანე სახელი (მინიმუმ 2 სიმბოლო).",
    errAge: "უნდა იყო 18 წლის ან მეტის.",
    errPhone: "შეიყვანე 9-ნიშნა ნომერი, მაგ. 555123456.",
    errAbout: "დაწერე რამდენიმე სიტყვა შენ შესახებ.",
    errCarModel: "შეიყვანე მანქანის მოდელი.",
    errPlate: "ნომრის ფორმატი: AA-123-AA.",
    changePhoto: "ფოტოს შეცვლა",
    uploading: "იტვირთება…",
    publishedRides: "გამოქვეყნებული მგზავრობები",
    myBookings: "ჩემი ჯავშნები",
    noBookings: "ჯერ არცერთი მგზავრობა არ დაგიჯავშნია.",
    accountDisabledBanner:
      "შენი, როგორც მძღოლის, წვდომა შეჩერებულია ადმინისტრატორის მიერ. მგზავრობების გამოქვეყნება ვერ შეძლებ. თუ ფიქრობ, რომ ეს შეცდომაა, მოგვწერე: info@gamiyole.me",
    reviews: "შეფასებები",
    noReviews: "შეფასებები ჯერ არ არის.",
    leaveReview: "როგორი იყო მგზავრობა —",
    reviewPlaceholder: "დაწერე რამდენიმე სიტყვა მგზავრობაზე…",
    sendReview: "შეფასების გაგზავნა",
    reviewSent: "მადლობა! შეფასება გამოქვეყნდა.",
    reviewNeedsRating: "აირჩიე ვარსკვლავები.",
    signInToReview: "შეფასების დასაწერად შედი სისტემაში.",
    yourRating: "შენი შეფასება",
    publishTitle: "გამოაქვეყნე მგზავრობა",
    publishHint: "შეავსე მარშრუტი და ადგილები — მგზავრები პირდაპირ დაჯავშნიან.",
    price: "ფასი ერთ ადგილზე (₾)",
    seatsOffered: "ადგილების რაოდენობა",
    departureTime: "გასვლის დრო",
    publish: "გამოქვეყნება",
    publishing: "ქვეყნდება…",
    ridePublished: "მგზავრობა გამოქვეყნდა!",
    errCities: "აირჩიე გასვლის და ჩასვლის ქალაქები.",
    errSameCity: "გასვლის და ჩასვლის ქალაქები უნდა განსხვავდებოდეს.",
    errDate: "აირჩიე დღევანდელი ან მომავალი თარიღი.",
    errTime: "მიუთითე გასვლის დრო.",
    errPrice: "შეიყვანე ფასი 0-დან 500 ლარამდე (0 = უფასო).",
    errSeats: "ადგილები უნდა იყოს 1-დან 8-მდე.",
    completeProfileFirst: "მგზავრობის გამოსაქვეყნებლად ჯერ შეავსე პროფილი.",
    signInToPublish: "გამოსაქვეყნებლად შედი სისტემაში.",
    prefsLabel: "პირობები",
    commentLabel: "კომენტარი (არასავალდებულო)",
    commentPlaceholder: "მაგ. შეხვედრის ადგილი, ბარგი, გაჩერებები გზაში…",
    badgeNoSmoking: "მოწევის გარეშე",
    badgePets: "ცხოველები დაშვებულია",
    badgeMusic: "მუსიკა",
    badgeAc: "კონდიციონერი",
    badgeLuggage: "დიდი ბარგი",
    badgeMaxTwoBack: "უკან მაქს. 2",
    modeOnce: "ერთჯერადი",
    modeRoutine: "განრიგი",
    routineHint:
      "ხშირად დადიხარ ერთსა და იმავე მარშრუტზე? აირჩიე დღეები და ვადა — ამ პერიოდის ყველა მგზავრობა მაშინვე გამოქვეყნდება.",
    repeatOn: "გამეორების დღეები",
    durationLabel: "მოქმედების ვადა",
    months1: "1 თვე",
    months2: "2 თვე",
    months3: "3 თვე",
    untilDate: "ბოლო დღე:",
    saveRoutine: "განრიგის შენახვა",
    routineSaved: "განრიგი შენახულია — პერიოდის ყველა მგზავრობა გამოქვეყნდა.",
    myRoutines: "ჩემი განრიგები",
    paused: "შეჩერებული",
    pause: "შეჩერება",
    resume: "განახლება",
    deleteBtn: "წაშლა",
    errDays: "აირჩიე კვირის მინიმუმ ერთი დღე.",
    deleteRoutineConfirm:
      "წაიშალოს განრიგი? ავტომატურად გამოქვეყნებული მომავალი მგზავრობები გაუქმდება.",
    adminTitle: "ადმინ პანელი",
    adminSubtitle: "მართე მძღოლები, მგზავრობები და შეფასებები",
    adminDrivers: "მძღოლი",
    adminRides: "აქტიური მგზავრობა",
    adminDisabled: "შეჩერებული",
    adminSearch: "ძებნა სახელით, ელფოსტით ან ნომრით…",
    adminAll: "ყველა",
    adminOnlyDrivers: "მძღოლები",
    adminOnlySuspended: "შეჩერებულები",
    adminUser: "მომხმარებელი",
    adminContact: "კონტაქტი",
    adminRating: "რეიტინგი",
    adminRidesCol: "მგზავრობები",
    adminStatus: "სტატუსი",
    adminActions: "მოქმედება",
    adminActive: "აქტიური",
    adminSuspendedBadge: "შეჩერებული",
    adminSuspend: "შეჩერება",
    adminRestore: "აღდგენა",
    adminVerify: "დადასტურება",
    adminUnverify: "გაუქმება",
    adminVerified: "დადასტურებული",
    adminView: "ნახვა",
    adminSuspendConfirm:
      "შეუჩერდეს ამ მომხმარებელს მძღოლის წვდომა? ის ვეღარ გამოაქვეყნებს მგზავრობებს.",
    adminNoUsers: "მომხმარებლები ვერ მოიძებნა.",
    adminRidesTitle: "აქტიური მგზავრობები",
    adminNoRides: "აქტიური მგზავრობები არ არის.",
    adminCancelRide: "გაუქმება",
    adminDeleteRide: "წაშლა",
    adminDeleteRideConfirm: "წაიშალოს ეს მგზავრობა სამუდამოდ?",
    adminNotAllowed: "ადმინ პანელზე წვდომა არ გაქვს.",
    adminReviewsFor: "შეფასება",
    adminDeleteReview: "შეფასების წაშლა",
    adminDeleteReviewConfirm: "წაიშალოს ეს შეფასება სამუდამოდ?",
    loading: "იტვირთება…",
    contact: "კონტაქტი",
    privacyPolicy: "კონფიდენციალურობის პოლიტიკა",
    allRights: "ყველა უფლება დაცულია",
    footerTag: "თანამგზავრობა საქართველოში — იმგზავრეთ ერთად, გადაიხადეთ ნაკლები.",
    backHome: "მთავარზე დაბრუნება",
    call: "დარეკვა",
  },
};

// Hook: t('key') returns the string in the active language, falling back to EN.
export function useT() {
  const lang = useSelector((state) => state.lang.lang);
  return (key) => STRINGS[lang]?.[key] ?? STRINGS.EN[key] ?? key;
}

export function useLang() {
  return useSelector((state) => state.lang.lang);
}

const WEEKDAYS = {
  EN: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  GE: ["კვირა", "ორშაბათი", "სამშაბათი", "ოთხშაბათი", "ხუთშაბათი", "პარასკევი", "შაბათი"],
};

// Indexed by Date#getDay() (0 = Sunday), used for routine day chips.
export const DAYS_SHORT = {
  EN: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  GE: ["კვი", "ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ"],
};

export const MONTHS = {
  EN: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  GE: ["იანვარი", "თებერვალი", "მარტი", "აპრილი", "მაისი", "ივნისი", "ივლისი", "აგვისტო", "სექტემბერი", "ოქტომბერი", "ნოემბერი", "დეკემბერი"],
};

export const formatDate = (isoDate, lang) => {
  if (!isoDate) return "";
  const d = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(d.getTime())) return isoDate;
  const day = WEEKDAYS[lang]?.[d.getDay()] ?? WEEKDAYS.EN[d.getDay()];
  const month = MONTHS[lang]?.[d.getMonth()] ?? MONTHS.EN[d.getMonth()];
  return lang === "GE"
    ? `${day}, ${d.getDate()} ${month}`
    : `${day}, ${month} ${d.getDate()}`;
};
